import { toastr } from 'react-redux-toastr'
import axios from 'axios'
import crypto from 'crypto'
import { getConfig, getUserToken } from '../util/helper'

import {isvalidCNPJ} from'../util/cnpj';

export async function login(values) {

    let retorno = false;

    return async dispatch => {
        const cfg = await getConfig('corporate')
        const hash = crypto.createHash('sha384')
        let newvalues = { ...values }
        if (newvalues.password) {
            newvalues.password = hash.update(values.password).digest('base64');
        }
        else {
            newvalues.password = '';
        }

        const catchNumbers = `${values.login}`.replace(/([^\d])+/gim, '');

        if (values.verifyCpfCnpj && (catchNumbers.length === 11 || catchNumbers.length === 14)) {
            const loginNumber = catchNumbers.replace(/^0+/, '');
            newvalues.login = validaCnpj.isvalidCNPJ(loginNumber) ? loginNumber : values.login;
        }

        try {
            // console.log('CONFIG', cfg)
            // console.log('BODY', newvalues)
            let r = await axios.post(`${cfg.baseUrl}/login`, newvalues)
            if (r) {
                retorno = r.data;
                dispatch({
                    type: 'USER_FETCHED',
                    payload: retorno
                })
            }
        } catch (e) {
            if (e.response) {
                e.response.data.errors.forEach(
                    error => toastr.error('Atenção', error))
            }
            else {
                toastr.error('Erro inesperado ao efetuar login.', e)
            }
        }
    }
}

export async function validaPreLogin(values) {

    let retorno = false;

    const cfg = await getConfig('corporate')
    const hash = crypto.createHash('sha384')
    let newvalues = { ...values }
    if (newvalues.password) {
        newvalues.password = hash.update(values.password).digest('base64');
    }
    else {
        newvalues.password = '';
    }

    const catchNumbers = `${values.login}`.replace(/([^\d])+/gim, '');

    if (values.verifyCpfCnpj && (catchNumbers.length === 11 || catchNumbers.length === 14)) {
        const loginNumber = catchNumbers.replace(/^0+/, '');
        newvalues.login = isvalidCNPJ(loginNumber) ? loginNumber : values.login;
    }

    try {
        // console.log('CONFIG', cfg)
        // console.log('BODY', newvalues)
        let r = await axios.post(`${cfg.baseUrl}/login`, newvalues)
        if (r) {
            retorno = r.data;
            // console.log('dispatch.retorno', retorno)
            return retorno;
        }
    } catch (e) {
        //console.log('ERRO_prelogin', e)
        if (e.response) {
            e.response.data.errors.forEach(
                error => toastr.error('Atenção', error))
        }
        else {
            toastr.error('Erro inesperado ao efetuar login.', e)
        }
    }
    
}

export async function validaUser(values) {
    let retorno = false;
    return async dispatch => {
        const cfg = await getConfig('corporate')
        const hash = crypto.createHash('sha384');
        let newvalues = { ...values }
        if (newvalues.password) {
            newvalues.password = hash.update(values.password).digest('base64');
        }
        else {
            newvalues.password = '';
        }
        try {
            let r = await axios.post(`${cfg.baseUrl}/login`, newvalues, {
                headers: {
                    Authorization: `bearer ${getUserToken()}`
                }
            })
            if (r) {
                retorno = true;
            }
        } catch (e) {
            retorno = false;
        }
        finally {
            dispatch({
                type: 'USER_VALIDATED',
                payload: retorno
            })
        }
    }
}
export async function validaLogin(values) {
    let retorno = false;
    let errorCode;
    return async dispatch => {
        dispatch({ type: 'CPF_LOGIN_VALIDATING' });
        const cfg = await getConfig('corporate')

        try {
            const endpoint = !values.hash ? `${cfg.baseUrl}/validarlogin` : `${cfg.baseUrl}/validarloginHash`;
            let r = await axios.post(endpoint, values, {
                headers: {
                    Authorization: `bearer ${getUserToken()}`
                }
            });

            if (r && r.status == 200) {
                retorno = true;
            }

        } catch (e) {
            if (!e || e.response.status == 401 || e.response.status == 400) {
                if (e.response) {
                    errorCode = e.response.data.errorCode
                }
            }
            retorno = false;
        }
        finally {
            dispatch({
                type: 'CPF_LOGIN_VALIDATED',
                payload: { retorno, errorCode }
            })
        }
    }
}

export async function alterpwd(login, password_old, password, password_confirmation) {
    const cfg = await getConfig('corporate')
    const hash = crypto.createHash('sha384');
    const hash2 = crypto.createHash('sha384');
    const hash3 = crypto.createHash('sha384');
    let newvalues = { login: login, password_old: password_old, password: password, password_confirmation: password_confirmation }

    if (password) {
        newvalues.password_old = hash.update(newvalues.password_old).digest('base64');
        newvalues.password = hash2.update(newvalues.password).digest('base64');
        newvalues.password_confirmation = hash3.update(newvalues.password_confirmation).digest('base64');
        return submitAXIOS(newvalues, `${cfg.baseUrl}/alterpwd`, 'PUT');
    }
}

export async function novopwd(hash, password, password_confirmation, willCp = true, ip) {
    const cfg = await getConfig("corporate");
    const hash2 = crypto.createHash("sha384");
    const hash3 = crypto.createHash("sha384");
    let newvalues = { hash, password, password_confirmation, ip };

    if (password) {
        if (willCp) {
            newvalues.password = hash2.update(newvalues.password).digest("base64");
            newvalues.password_confirmation = hash3.update(newvalues.password_confirmation).digest("base64");
        }
        return await submitAXIOS(newvalues, `${cfg.baseUrl}/newpwd`, "PUT");
    }
}
export async function esquecipwd(values) {
    const cfg = await getConfig('corporate')
    return submitAXIOS(values, `${cfg.baseUrl}/esquecipwd`, 'POST');
}

async function submitAXIOS(values, url, type) {
    return async dispatch => {
        switch (type) {
            case 'POST':
                axios.post(url, values, {
                    headers: {
                        Authorization: `bearer ${getUserToken()}`
                    }
                })
                    .then(resp => {
                        dispatch([
                            { type: 'USER_VALIDATED', payload: resp.data, sucesso: true }
                        ])
                    })
                    .catch(e => {
                        if (e.response) {
                            e.response.data.errors.forEach(
                                error => toastr.error('Erro', error))
                        }
                        else {
                            toastr.error('Erro inesperado', e)
                        }
                    })

                break;
            case 'PUT':
                axios.put(url, values, {
                    headers: {
                        Authorization: `bearer ${getUserToken()}`
                    }
                })
                    .then(resp => {
                        dispatch([
                            { type: 'USER_VALIDATED', payload: resp.data, sucesso: true }

                        ])
                    })
                    .catch(e => {
                        if (e.response && e.response.data && e.response.data.error) {
                            toastr.error('Atenção', e.response.data.error)
                        } else if (e.response) {
                            e.response.data.errors.forEach(
                                error => toastr.error('Atenção', error))
                        } else {
                            toastr.error('Erro inesperado', e)
                        }
                    })

                break;
            default:
                break;
        }
    }
}

export async function logout() {
    return { type: 'TOKEN_VALIDATED', payload: false }
}

export async function validateToken(token) {
    const cfg = await getConfig('corporate')
    return dispatch => {
        if (token) {
            axios.post(`${cfg.baseUrl}/validateToken`, { token }, {
                headers: {
                    Authorization: `bearer ${getUserToken()}`
                }
            })
                .then(resp => {
                    dispatch({ type: 'TOKEN_VALIDATED', payload: resp.data.valid })
                })
                .catch(e => dispatch({ type: 'TOKEN_VALIDATED', payload: false }))
        } else {
            dispatch({ type: 'TOKEN_VALIDATED', payload: false })
        }
    }
}
export async function reset() {
    return dispatch => {
        dispatch({ type: 'RESET' })
    }
}

export async function validaHash(hash) {
    let retorno = false;
    return async dispatch => {
        dispatch({
            type: 'HASH_VALIDATING',
        });
        const cfg = await getConfig('corporate')
        try {
            let r = await axios.get(`${cfg.baseUrl}/validar-hash?hash=${hash}`)
            retorno = r.status === 200;
        } catch (e) {
            retorno = false;
        } finally {
            dispatch({
                type: 'HASH_VALIDATED',
                payload: retorno
            });
        }
    };
};

export async function validaUsuario(values) {
    const cfg = await getConfig('corporate')
    try {
        const result = await axios.get(`${cfg.baseUrl}/validarlogin/validar-user?userid=${values}`)
        if (result) {
            if(result.status !== 200)
                throw result.errors;
            return result;
        }
    } catch (error) {
        //console.log(error);
        throw error;
    }
}

export async function getIntegracaoSistema() {
    const cfg = await getConfig('corporate')
    try {
        const result = await axios.get(`${cfg.baseUrl}/validarlogin/get-integracao-sistema?Chave=TOKENAUTH`)
        if (result) {
            return result;
        }
    } catch (error) {
        toastr.error('Erro inesperado ao logar!', error)
        //console.log(error)
    }
}
